module.exports = __webpack_public_path__ + "static/media/step-three-small.49c05707.jpg";